/**
 * Error categories for classification and handling
 *
 * Each category represents a different type of error with specific handling patterns.
 * This is a pure data contract - the classification logic is in pers-shared-patterns.
 */
export var ErrorCategory;
(function (ErrorCategory) {
    /**
     * Input validation failures (malformed data, missing required fields, format errors)
     */
    ErrorCategory["VALIDATION"] = "VALIDATION";
    /**
     * Business rule violations (domain logic constraints, business policy violations)
     */
    ErrorCategory["DOMAIN_RULE"] = "DOMAIN_RULE";
    /**
     * Application/technical issues (configuration errors, data processing failures, logic errors)
     */
    ErrorCategory["TECHNICAL"] = "TECHNICAL";
    /**
     * Infrastructure/system failures (database down, external services unavailable, network issues)
     */
    ErrorCategory["INFRASTRUCTURE"] = "INFRASTRUCTURE";
    /**
     * Security violations (authentication failures, authorization denials, suspicious activity)
     */
    ErrorCategory["SECURITY"] = "SECURITY";
    /**
     * Usage limit violations (API rate limits, quota exceeded, throttling)
     */
    ErrorCategory["RATE_LIMIT"] = "RATE_LIMIT";
    /**
     * Request timeout violations (operation took too long, deadline exceeded)
     */
    ErrorCategory["TIMEOUT"] = "TIMEOUT";
    /**
     * Unclassified errors (catch-all for errors that don't fit other categories)
     */
    ErrorCategory["UNKNOWN"] = "UNKNOWN";
})(ErrorCategory || (ErrorCategory = {}));
/**
 * Type guard functions for category-specific error handling
 */
export const isValidationError = (error) => error.category === ErrorCategory.VALIDATION;
export const isDomainRuleError = (error) => error.category === ErrorCategory.DOMAIN_RULE;
export const isTechnicalError = (error) => error.category === ErrorCategory.TECHNICAL;
export const isInfrastructureError = (error) => error.category === ErrorCategory.INFRASTRUCTURE;
export const isSecurityError = (error) => error.category === ErrorCategory.SECURITY;
export const isRateLimitError = (error) => error.category === ErrorCategory.RATE_LIMIT;
export const isTimeoutError = (error) => error.category === ErrorCategory.TIMEOUT;
export const isUnknownError = (error) => error.category === ErrorCategory.UNKNOWN;
//# sourceMappingURL=error-classification-enums.js.map